export default __webpack_public_path__ + "static/media/image-hero-phone.d0056b2e.png";